import { Realty, services } from '@ambita/ambita-components-core';
import { ApiSingleHeritage } from '../../../typings/CadastreReport';

const util = services.util;

function transformSingleHeritages(singleHeritageData: Realty.ApiResponse) {
  if (singleHeritageData.items && singleHeritageData.items.length > 0) {
    const singleHeritages: ApiSingleHeritage[] = singleHeritageData.items;
    const retObject: any = {
      singleHeritages: []
    };

    singleHeritages.forEach((heritage: ApiSingleHeritage) => {
      const tmpObj: any = util.pick(heritage, [
        'heritageType',
        'preservationTypeCode',
        'categoryCode',
        'registeredDate',
        'lastUpdatedDate',
        'links'
      ]);

      tmpObj.localityNumber = heritage.ident.localityNumber;
      retObject.singleHeritages.push(tmpObj);
    });

    return retObject;
  }
}

export default transformSingleHeritages;
